var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "12 12 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.39 12H14.7237C14.0163 12 13.338 12.2811 12.838 12.7811C12.338 13.2811 12.0569 13.9594 12.0569 14.6669V20C12.0569 20.7074 12.338 21.3857 12.838 21.8857C13.338 22.3857 14.0163 22.6669 14.7237 22.6669H33.39C34.0975 22.6669 34.7757 22.3857 35.2757 21.8857C35.7757 21.3857 36.0569 20.7074 36.0569 20V14.6669C36.0569 13.9594 35.7757 13.2811 35.2757 12.7811C34.7757 12.2811 34.0975 12 33.39 12V12ZM14.7237 20V14.6669H33.39V20H14.7237Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7237 24H14.7237C14.0163 24 13.338 24.2811 12.838 24.7811C12.338 25.2811 12.0569 25.9594 12.0569 26.6669V33.3337V33.3337C12.0569 34.0411 12.338 34.7189 12.838 35.2194C13.338 35.7194 14.0163 36.0006 14.7237 36.0006H22.7237C23.4312 36.0006 24.1095 35.7194 24.6095 35.2194C25.1095 34.7194 25.3906 34.0411 25.3906 33.3337V26.6674C25.3906 25.96 25.11 25.2817 24.6095 24.7817C24.1095 24.2817 23.4312 24.0006 22.7237 24.0006V24ZM14.7237 33.3331V26.6669H22.7237V33.3337H14.7237V33.3331Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.39 24H29.39C28.6826 24 28.0043 24.2811 27.5043 24.7811C27.0043 25.2811 26.7231 25.9594 26.7231 26.6669V33.3337C26.7231 34.0411 27.0037 34.7189 27.5043 35.2194C28.0043 35.7194 28.6826 36.0006 29.39 36.0006H33.39C34.0974 36.0006 34.7757 35.7194 35.2757 35.2194C35.7757 34.7194 36.0569 34.0411 36.0569 33.3337V26.6674C36.0569 25.96 35.7757 25.2817 35.2757 24.7817C34.7757 24.2817 34.0974 24.0006 33.39 24.0006V24ZM29.39 33.3326V26.6663H33.39V33.3331H29.39V33.3326Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_10468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(12.0569 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.926387b7f2facae19fb8d29ab649e245.svg";
export { ForwardRef as ReactComponent };